import { HTTPError } from 'ky';

import { fastApi } from '@/services/api';

const PATH = 'v1/customer/form/privacy-notice';

type PrivacyGetResponse = {
  date: string;
};

export const getPrivacy = async () => {
  return fastApi
    .get(PATH)
    .json<PrivacyGetResponse>()
    .catch((error) => {
      if (error instanceof HTTPError && error.response.status === 404) return null;

      throw error;
    });
};

export const postPrivacy = async () => {
  await fastApi.post(PATH);
};
